import { z } from 'zod';

export const createConversationSchema = z
  .object({
    selectedContacts: z.array(z.any()).optional(),
    groupName: z.string().optional(),
    groupDescription: z
      .string()
      .max(200, 'The description can`t be longer than 200 characters.')
      .optional()
      .or(z.literal('')),
  })
  .refine(
    (data) => {
      // If groupDescription is filled, groupName must be required
      if (data.groupDescription && data.groupDescription.trim() !== '') {
        return data.groupName && data.groupName.trim() !== '';
      }
      return true;
    },
    {
      message: 'It is necessary to add a group name to create a group.',
      path: ['groupName'],
    }
  )
  .refine(
    (data) => {
      // If groupName is filled, it cannot have more than 50 characters
      if (data.groupName && data.groupName.trim() !== '') {
        return data.groupName.trim().length <= 50;
      }
      return true;
    },
    {
      message: 'Group name can`t be longer than 50 characters.',
      path: ['groupName'],
    }
  )
  .refine(
    (data) => {
      // If groupName is filled, it must start with a letter
      if (data.groupName && data.groupName.trim() !== '') {
        return /^[a-zA-Z]/.test(data.groupName.trim());
      }
      return true;
    },
    {
      message: 'Group name should start with a letter. Please rename it.',
      path: ['groupName'],
    }
  )
  .refine(
    (data) => {
      // If groupName is filled, it should not contain spaces
      if (data.groupName && data.groupName.trim() !== '') {
        return !/\s/.test(data.groupName.trim());
      }
      return true;
    },
    {
      message: 'Spaces are not allowed. Please remove them.',
      path: ['groupName'],
    }
  )
  .refine(
    (data) => {
      // If groupName is filled, it should only contain letters, numbers, _ and -
      if (data.groupName && data.groupName.trim() !== '') {
        return /^[a-zA-Z0-9_-]+$/.test(data.groupName.trim());
      }
      return true;
    },
    {
      message: 'Group name can only contain letters, numbers, _ and -',
      path: ['groupName'],
    }
  )
